window._env_ = {
  CHECKOUT_PM_HOST: "https://api.platform.pagopa.it/payment-manager",
  CHECKOUT_AUTH_SERVICE_HOST: "",
  CHECKOUT_SURVEY_SHOW: "1",
  CHECKOUT_API_ECOMMERCE_BASEPATH_AUTH_V1: "/ecommerce/checkout/auth/v1",
  CHECKOUT_VERSION: "main:0d0d2ce8ae1fcbd00753c6d70860db620a9a0d56",
  CHECKOUT_GDI_CHECK_TIMEOUT: "20000",
  CHECKOUT_API_AUTH_SERVICE_BASEPATH_V1: "/checkout/auth-service/v1",
  CHECKOUT_PAGOPA_APIM_HOST: "https://api.platform.pagopa.it",
  CHECKOUT_API_PAYMENT_TRANSACTIONS_BASEPATH: "/api/checkout/payment-transactions/v1",
  CHECKOUT_DONATIONS_URL: "https://api.platform.pagopa.it/donations/api/v1/availabledonations",
  CHECKOUT_PAGOPA_ASSETS_CDN: "https://assets.cdn.platform.pagopa.it/payment-methods",
  CHECKOUT_NPG_SDK_WEB_ORIGIN: "https://xpay.nexigroup.com",
  CHECKOUT_API_ECOMMERCE_BASEPATH_V2: "/ecommerce/checkout/v2",
  CHECKOUT_API_TIMEOUT: "10000",
  CHECKOUT_POLLING_ACTIVATION_ATTEMPTS: "16",
  CHECKOUT_API_FEATURE_FLAGS_BASEPATH: "/checkout/feature-flags/v1",
  CHECKOUT_API_PAYMENT_ACTIVATIONS_BASEPATH: "/checkout/payments/v1",
  CHECKOUT_NPG_SDK_URL: "https://xpay.nexigroup.com/monetaweb/resources/hfsdk.js",
  CHECKOUT_API_CLIENT_RETRY_NUMBERS: "5",
  CHECKOUT_API_WALLET_BASEPATH_V1: "/checkout/payment-wallet/v1",
  CHECKOUT_RECAPTCHA_SITE_KEY: "6LdFqIoqAAAAAGpcltgCyhRjPIR_2T-hNgtk0KQi",
  CHECKOUT_PAGOPA_LOGOS_CDN: "https://assets.cdn.io.italia.it/logos/abi",
  CHECKOUT_API_CLIENT_RETRY_DELAY: "2000",
  CHECKOUT_PM_API_BASEPATH: "/pp-restapi/v4",
  CHECKOUT_API_ECOMMERCE_BASEPATH: "/ecommerce/checkout/v1",
  CHECKOUT_POLLING_ACTIVATION_INTERVAL: "6000",
  CHECKOUT_ENV: "PROD",
  CHECKOUT_NPG_SDK_INTEGRITY_URL: "",
}
